
import { Component, EventEmitter, Input, OnChanges, OnInit, Output, SimpleChanges } from '@angular/core';
import { NgbModal } from '@ng-bootstrap/ng-bootstrap';
import { DataEntryPanelComponent } from './data-entry-panel/data-entry-panel.component';
import { MeasurementPaletteComponent } from './measurement-palette/measurement-palette.component';
import { WhiteboardingPaletteComponent } from './whiteboarding-palette/whiteboarding-palette.component';
import { MarkersPaletteComponent } from './markers-palette/markers-palette.component';
import { IncidentCreatorButtonComponent } from './incident-creator-button/incident-creator-button.component';
import { FeedsUiDialogComponent } from './feeds-ui-dialog/feeds-ui-dialog.component';
import { TwitterUiDialogComponent } from './twitter-ui-dialog/twitter-ui-dialog.component';
import { ImporterService } from '../../../core/services/wrench-services/importer.service';
import { MarkersService } from '../../../core/services/wrench-services/markers.service';
import { CreateSavedViewDialogComponent } from './create-saved-view-dialog/create-saved-view-dialog.component';
import { CoreService } from '../../../core/services/core.service';
import * as Cesium from 'cesium';
import { DeleteSavedViewDialogComponent } from './delete-saved-view-dialog/delete-saved-view-dialog.component';
import { UpdateSavedViewDialogComponent } from './update-saved-view-dialog/update-saved-view-dialog.component';
import { SavedView } from '../../../core/interfaces/view.model';
import { CameraService } from '../../../core/services/camera.service';


@Component({
  selector: 'app-wrench-action-drawer',
  standalone: true,
  imports: [MarkersPaletteComponent, IncidentCreatorButtonComponent],
  templateUrl: './wrench-action-drawer.component.html',
  styleUrl: './wrench-action-drawer.component.css',
})
export class WrenchActionDrawerComponent implements OnInit, OnChanges {
  constructor(
    private modalService: NgbModal,
    private importerService: ImporterService,
    private markerSelectionService: MarkersService,
    private coreService: CoreService,
    private cameraService: CameraService
  ) { }

  ngOnChanges(changes: SimpleChanges) {
    if (changes['sessionName']) {
      this.isLiveMode = this.sessionName === 'Live Mode';
      this.actions = this.getActions();
    }
  }

  drawerOpen = false;
  showLocationPalette = false;
  showIncidentcreator = false;
  toolActive = false;
  drawerExpanded: boolean = false;
  createIncidentIcon:boolean=false;
  // savedViews: { name: string; isDefault: boolean; guid: string }[] = [];
  savedViews: SavedView[] = []

  selectedMarker: { name: string; url: string } | null = null;
  isLiveMode: boolean = false;
  @Input() sessionName: string =''; 
  @Output() modalOpenState = new EventEmitter<boolean>();
  @Output() measurementToolState = new EventEmitter<boolean>();
  @Output() toolState = new EventEmitter<boolean>();
  @Output() actionSelected = new EventEmitter<string>();

  actions = [
    {
      icon: 'fa fa-ruler',
      title: 'Measurement',
      action: () => this.openMeasurementModal(),
    },
    {
      icon: 'fa fa-pencil-alt',
      title: 'Mark',
      action: () => this.openWhiteboardingPalette(),
    },
    {
      icon: 'fa fa-person-circle-exclamation',
      title: 'Location',
      action: () => this.openLocationPalette(),
    },
    {
      icon: 'fa fa-map-location-dot',
      title: 'incident location',
      action: () => this.openIncidentcreator(),
      visible: () => !this.showIncidentcreator
    },
    {
      icon: 'fa fa-file-arrow-up',
      title: 'Import file',
      action: () => this.openImporterURL(),
    },
    { icon: 'fa fa-rss', title: 'Feed', action: () => this.openFeedsUiDialog() },
    {
      icon: 'fa fa-brands fa-x-twitter',
      title: 'Twitter',
      action: () => this.openTwitterUiDialog(),
    },
    {
      icon: 'fa fa-layer-group',
      title: 'Layers',
      action: () => this.openLayersModal(),
    },
  ];

  ngOnInit(): void {
    this.isLiveMode = this.sessionName === 'Live Mode';
    this.savedViews = JSON.parse(localStorage.getItem('savedViews') || '[]');
    this.actions = this.getActions();
  }

  toggleDrawer() {
    this.drawerOpen = !this.drawerOpen;
  }

  emitAction(action: string) {
    this.actionSelected.emit(action);
    this.drawerOpen = false;
    this.showLocationPalette = false;
  }

  openLayersModal(): void {
    if (this.toolActive) return;
    this.toolActive = true;
    this.drawerOpen = false;
    this.toolState.emit(true);
    const modalRef = this.modalService.open(DataEntryPanelComponent, {
      windowClass: 'bottom-left-modal',
      backdrop: 'static',
      keyboard: false,
      backdropClass: 'transparent-backdrop'
    });
    modalRef.result.finally(() => {
      this.modalOpenState.emit(false);
      this.toolState.emit(false);
      this.toolActive = false;
    });
  }

  openMeasurementModal(): void {
    if (this.toolActive) return;
    this.toolActive = true;
    this.drawerOpen = false;
    this.measurementToolState.emit(true);
    this.toolState.emit(true);
    const modalRef = this.modalService.open(MeasurementPaletteComponent, {
      windowClass: 'bottom-left-modal',
      backdrop: 'static',
      keyboard: false,
      backdropClass: 'transparent-backdrop',
      size: 'lg'
    });
    modalRef.result.finally(() => {
      this.modalOpenState.emit(false);
      this.measurementToolState.emit(false);
      this.toolState.emit(false);
      this.toolActive = false;
    });
  }

  openWhiteboardingPalette(): void {
    if (this.toolActive) return;
    this.toolActive = true;
    this.drawerOpen = false;
    this.toolState.emit(true);
    const modalRef = this.modalService.open(WhiteboardingPaletteComponent, {
      windowClass: 'bottom-left-modal',
      backdrop: false,
      keyboard: false,
      size: 'sm'
    });
    modalRef.result.finally(() => {
      this.modalOpenState.emit(false);
      this.toolState.emit(false);
      this.toolActive = false;
    });
  }

  openLocationPalette(): void {
    if (this.toolActive) return;
    this.showIncidentcreator = false;
    this.showLocationPalette = true;
    this.toolState.emit(true);
    this.toolActive = true;
  }

  onCloseLocationPalette(): void {
    this.showLocationPalette = false;
    this.toolState.emit(false);
    this.toolActive = false;
  }

  openIncidentcreator(): void {
    if (this.toolActive)
      {
       this.createIncidentIcon=true;
       return;
      } 
      else{
    this.showLocationPalette = false;
    this.showIncidentcreator = true;
    this.toolState.emit(true);
    this.toolActive = true;
      }
  }

  onCloseIncidentcreator(): void {
    this.showIncidentcreator = false;
    this.toolState.emit(false);
    this.toolActive = false;
  }

  openImporterURL(): void {
    if (this.toolActive) return;
    this.toolActive = true;
    this.importerService.importFile().finally(() => {
      this.toolActive = false;
    });
  }

  openFeedsUiDialog(): void {
    if (this.toolActive) return;
    this.toolActive = true;
    this.drawerOpen = false;
    this.toolState.emit(true);
    const modalRef = this.modalService.open(FeedsUiDialogComponent, {
      windowClass: 'bottom-left-modal',
      backdrop: 'static',
      keyboard: false,
      backdropClass: 'transparent-backdrop'
    });
    modalRef.result.finally(() => {
      this.modalOpenState.emit(false);
      this.toolState.emit(false);
      this.toolActive = false;
    });
  }

  openTwitterUiDialog(): void {
    if (this.toolActive) return;
    this.toolActive = true;
    this.drawerOpen = false;
    this.toolState.emit(true);
    const modalRef = this.modalService.open(TwitterUiDialogComponent, {
      windowClass: 'bottom-left-modal',
      backdrop: 'static',
      keyboard: false,
      backdropClass: 'transparent-backdrop'
    });
    modalRef.result.finally(() => {
      this.modalOpenState.emit(false);
      this.toolState.emit(false);
      this.toolActive = false;
    });
  }


  onMarkerSelected(marker: any) {
    this.markerSelectionService.setSelectedMarker(marker);
  }

  onAddNew() {
    const modalRef = this.modalService.open(CreateSavedViewDialogComponent, {
      size: 'lg',
      centered: true,
      backdrop: 'static',
      keyboard: false,
    });

    modalRef.result.then(
      (result) => {
        if (result) {
          this.savedViewInLocalStorage(result); // existing logic
        }
      },
      () => { } // dismissed
    );
  }


  savedViewInLocalStorage(newView: { name: string; isDefault: boolean; guid: string }) {

    // Get existing saved views
    let savedViews = JSON.parse(localStorage.getItem('savedViews') || '[]');

    if (newView.isDefault) {
      // Unset default for all other records
      savedViews = savedViews.map((v: any) => ({ ...v, isDefault: false }));

      // Insert the new default at index 0
      savedViews = [newView, ...savedViews];
    } else {
      // Just append at the end
      savedViews.push(newView);
    }

    // Save back to localStorage
    localStorage.setItem('savedViews', JSON.stringify(savedViews));

    // Update local state so UI refreshes
    this.savedViews = savedViews;
  }


  onSelectSavedView(item: any) {
    const pos = item.position;
    const destination = Cesium.Cartesian3.fromRadians(pos.longitude, pos.latitude, pos.height);
    this.cameraService.goToDestination(destination, {
      heading: item.heading,
      pitch: item.pitch,
      roll: item.roll
    });
  }

  toggleViewAll() {
    this.drawerExpanded = !this.drawerExpanded;
  }

  openDeleteModal(view: any, event: MouseEvent) {
    event.preventDefault(); // prevent default right-click menu

    const modalRef = this.modalService.open(DeleteSavedViewDialogComponent, {
      centered: true,
      backdrop: 'static'
    });

    modalRef.componentInstance.id = view.id;

    modalRef.result.then((result) => {
      if (result === 'deleted') {
        // refresh list from localStorage
        this.savedViews = JSON.parse(localStorage.getItem('savedViews') || '[]');
      }
    }).catch(() => { });
  }

  openUpdateModal(view: any, event: MouseEvent) {
    event.preventDefault();

    const modalRef = this.modalService.open(UpdateSavedViewDialogComponent, {
      centered: true,
      backdrop: 'static'
    });

    modalRef.componentInstance.view = { ...view }; // pass a copy to modal

    modalRef.result.then((result) => {
      if (result === 'updated') {
        // refresh from localStorage
        this.savedViews = JSON.parse(localStorage.getItem('savedViews') || '[]');
      }
    }).catch(() => { });
  }

  updateSavedView(updatedView: any) {
    let saved = JSON.parse(localStorage.getItem('savedViews') || '[]');

    // update the matching view
    saved = saved.map((x: any) =>
      x.guid === updatedView.guid ? { ...x, ...updatedView } : x
    );

    localStorage.setItem('savedViews', JSON.stringify(saved));

    // refresh UI
    this.savedViews = saved;
  }

 /**
 * Returns actions based on live mode
 */
  getActions(): any[] {
    if (this.isLiveMode) {
      // Only these actions when live mode is true
      return [
        {
          icon: 'fa fa-ruler',
          title: 'Measurement',
          action: () => this.openMeasurementModal(),
        },
        {
          icon: 'fa fa-pencil-alt',
          title: 'Mark',
          action: () => this.openWhiteboardingPalette(),
        },
        {
          icon: 'fa fa-person-circle-exclamation',
          title: 'Location',
          action: () => this.openLocationPalette(),
        },
        {
          icon: 'fa fa-rss',
          title: 'Feed',
          action: () => this.openFeedsUiDialog(),
        },
        {
          icon: 'fa fa-brands fa-x-twitter',
          title: 'Twitter',
          action: () => this.openTwitterUiDialog(),
        },
      ];
    } else {
      // Default actions when live mode is false
      return [
        {
          icon: 'fa fa-ruler',
          title: 'Measurement',
          action: () => this.openMeasurementModal(),
        },
        {
          icon: 'fa fa-pencil-alt',
          title: 'Mark',
          action: () => this.openWhiteboardingPalette(),
        },
        {
          icon: 'fa fa-person-circle-exclamation',
          title: 'Location',
          action: () => this.openLocationPalette(),
        },
        {
          icon: 'fa fa-map-location-dot',
          title: 'incident location',
          action: () => this.openIncidentcreator(),
          visible: () => !this.showIncidentcreator,
        },
        {
          icon: 'fa fa-file-arrow-up',
          title: 'Import file',
          action: () => this.openImporterURL(),
        },
        {
          icon: 'fa fa-rss',
          title: 'Feed',
          action: () => this.openFeedsUiDialog(),
        },
        {
          icon: 'fa fa-brands fa-x-twitter',
          title: 'Twitter',
          action: () => this.openTwitterUiDialog(),
        },
        {
          icon: 'fa fa-layer-group',
          title: 'Layers',
          action: () => this.openLayersModal(),
        },
      ];
    }
  }


}